import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { verifyStateSelector } from '../../../redux/account-verification/account-verification.selectors';
import VerificationLoadingPopup from './verification-loading-popup';
const mapStateToProps = createStructuredSelector({
  verifyState: verifyStateSelector
});
export default connect(mapStateToProps)(VerificationLoadingPopup);